// Dependencias
import axios, { AxiosError } from 'axios';
import { StatusCodes } from 'http-status-codes';

// Errores
import { AuthError } from '../errors/common.error';
import { ServerError } from '../errors/core.error';

// Schemas de los datos
import { AuthSchema } from '../schemas/auth.schema';

const client = axios.create({
  baseURL: location.origin,
  headers: {
    'Content-Type': 'application/json'
  }
});

/**
 * Realiza Auth al servidor de la API
 * @param user Esquema de usuario y contraseña para realizar auth
 */
export async function login(user: AuthSchema) {
  try {
    return await client.post('/login', user);
  } catch (error) {
    // Se valida la respuesta para definir el tipo de error que se mandara
    if (error instanceof AxiosError) {
      const statusCode = error.response?.status;

      if ([StatusCodes.FORBIDDEN, StatusCodes.UNAUTHORIZED].includes(statusCode!))
        throw new AuthError();

      if ([StatusCodes.BAD_REQUEST, StatusCodes.INTERNAL_SERVER_ERROR].includes(statusCode!))
        throw new ServerError();
    }
  }
}

/**
 * Elimnina la cookie par a cerrar la sesión de la aplicación
 */
export async function logout() {
  try {
    return await client.post('/logout');
  } catch (error) {
    // Se valida la respuesta para definir el tipo de error que se mandara
    if (error instanceof AxiosError) {
      const statusCode = error.response?.status;

      if ([StatusCodes.FORBIDDEN, StatusCodes.UNAUTHORIZED].includes(statusCode!))
        throw new AuthError();
      
      if ([StatusCodes.BAD_REQUEST, StatusCodes.INTERNAL_SERVER_ERROR].includes(statusCode!))
        throw new ServerError();
    }
  }
}
